import { Color, CreateElement, Rect, Scale } from ".././MyHelpers";
import { PlayWindow } from "../api";
import { ZIndex } from "../ZIndex";

export class WinLineMarker
{
	public element: HTMLElement;
	public containerElement: HTMLElement;

	public lineIndex: number;

	public constructor() 
	{
		this.containerElement = CreateElement("div", {classes: ["line-marker-container"], style: {
			flexGrow: "1",
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		}});

		this.element = document.createElement("div");
		this.element.classList.add("line-marker");

		this.element = CreateElement("div", {classes: ["line-marker"], innerHTML: "00", style: {
			borderRadius: Scale.XYpx(25),
			width: Scale.Wpx(100),
			textAlign: "center",
			fontFamily: "NotoSansDisplay-Bold", // default font
			fontSize: Scale.fhpx(30),
			color: "white",
			textShadow: "0px 0px 2px black, 0px 0px 4px black"
			
		}});
		this.element.style.zIndex=ZIndex.WinLines.toString();

		this.containerElement.appendChild(this.element);

	}

	public Show(lineIndex: number): void {
		this.element.innerHTML = "" + (lineIndex + 1);
		this.element.style.visibility = "visible";
	}

	public Hide(): void {
		this.element.style.visibility = "hidden";
	}
}

export class WinLineMarkers
{
	private leftMarkers: WinLineMarker[] = [];
	private leftVisibleMarker: WinLineMarker = null;

	private rightMarkers: WinLineMarker[] = [];
	private rightVisibleMarker: WinLineMarker = null;

	private leftContainer: HTMLElement = null;
	private rightContainer: HTMLElement = null;

	//private view: HTMLElement = null;
	private lines: number[][] = [];

	constructor(slotWindow: Rect, slotWindowSymbolSize: PlayWindow, lines: number[][]) 
	{
		let symbolHeight = slotWindow.height / slotWindowSymbolSize.Height;

		let leftWidth: number = Scale.W(60);
		let leftOffset: number = Scale.X(5);

		let rightWidth: number = Scale.W(60);
		let rightOffset: number = Scale.X(5);

		this.leftContainer = CreateElement("div", {classes: ["line-markers-left"], style: {
			position: "absolute",
			top: slotWindow.y + "px",
			height: slotWindow.height + "px",
			left: (slotWindow.x - leftWidth - leftOffset) + "px",
			width: leftWidth + "px",
			display: "flex",
			flexDirection: "column",
			alignItems: "stretch"
		
		}});

		this.leftContainer.style.zIndex=ZIndex.WinLines.toString();

		this.rightContainer = CreateElement("div", {classes: ["line-markers-left"], style: {
			position: "absolute",
			top: slotWindow.y + "px",
			height: slotWindow.height + "px",
			left: (slotWindow.x + slotWindow.width + rightOffset) + "px",
			width: rightWidth + "px",
			display: "flex",
			flexDirection: "column",
			alignItems: "stretch"
		}});

		this.rightContainer.style.zIndex=ZIndex.WinLines.toString();


		for (let i = 0; i < slotWindowSymbolSize.Height; i++) {

			// create markers
			let leftMarker: WinLineMarker = new WinLineMarker();
			let rightMarker: WinLineMarker = new WinLineMarker();

			this.leftContainer.appendChild(leftMarker.containerElement);
			this.rightContainer.appendChild(rightMarker.containerElement);
			
			// hide markers by default
			leftMarker.Hide();
			rightMarker.Hide();

			this.leftMarkers.push(leftMarker);
			this.rightMarkers.push(rightMarker);
		}

		this.lines = lines;
	}

	public Show(lineIndex: number, color: Color): void {

		if (this.leftVisibleMarker != null) {
			this.leftVisibleMarker.Hide();
		}

		if (this.rightVisibleMarker != null) {
			this.rightVisibleMarker.Hide();
		}

		let rowLeft = this.lines[lineIndex][0];

		this.leftVisibleMarker = this.leftMarkers[rowLeft];
		this.leftVisibleMarker.element.style.backgroundColor = color.toRgb();
		this.leftVisibleMarker.Show(lineIndex);

		let rowRight = this.lines[lineIndex][this.lines[lineIndex].length -1];

		this.rightVisibleMarker = this.rightMarkers[rowRight];
		this.rightVisibleMarker.element.style.backgroundColor = color.toRgb();
		this.rightVisibleMarker.Show(lineIndex);
	}

	public Hide(): void {
		if (this.leftVisibleMarker != null) {
			this.leftVisibleMarker.Hide();
			this.leftVisibleMarker = null;
		}

		if (this.rightVisibleMarker != null) {
			this.rightVisibleMarker.Hide();
			this.rightVisibleMarker = null;
		}
	}

	public LeftView(): HTMLElement {
		return this.leftContainer;
	}

	public RightView(): HTMLElement {
		return this.rightContainer;
	}
}